import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';
import { ACTION, BULK_ACTIONS_RESOURCES, PAGE_NAMES } from 'constant';
import ListBulkRefund from './submodules/list/List';
import CreateBulkRefund from './submodules/create';

const BulkRefund: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRouteV2
				exact
				configPageName={PAGE_NAMES.bulkActions}
				configResourceName={BULK_ACTIONS_RESOURCES.bulkRefund}
				configActionName={ACTION.getBulkRefundCsvDetails}
				path={`${path}/list`}
				component={ListBulkRefund}
			/>
			<AuthorizedRouteV2
				exact
				configPageName={PAGE_NAMES.bulkActions}
				configResourceName={BULK_ACTIONS_RESOURCES.bulkRefund}
				configActionName={ACTION.uploadBulkRefundCsv}
				path={`${path}/create`}
				component={CreateBulkRefund}
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default BulkRefund;
